export default {
    methods: {
        alertPleaseLogin() {
            this.$swal({
                title: this.$PPlusEngine.getDictionary(this.$route.params.lang, 
                    'กรุณาเข้าสู่ระบบก่อน', 
                    'Please sign in first'),
                text: this.$PPlusEngine.getDictionary(this.$route.params.lang, 
                    'เฉพาะสมาชิกเท่านั้นถึงทำการดูเนื้อหาได้', 
                    'Only paid member can view this page'),
                type: 'warning'
            });
        },
        alertPleaseMakePayment(router) {
            this.$swal({
                title: this.$PPlusEngine.getDictionary(this.$route.params.lang, 
                    'โปรดทำการชำระเงิน', 
                    'Please make payment first'),
                text: this.$PPlusEngine.getDictionary(this.$route.params.lang, 
                    'บัญชีของท่านยังไม่ได้ทำการชำระเงินเพื่อเข้ารับการอบรม', 
                    'Your account has not been yet paid for attending the training course'),
                type: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#cc4a4e',
                cancelButtonColor: '#ccc',
                confirmButtonText: this.$PPlusEngine.getDictionary(this.$route.params.lang, 
                    'ไปหน้าจ่ายเงิน', 
                    'Go to Payment')
            }).then((result) => {
                if (result.value) {
                    router.push('/' + this.$route.params.lang +'/payment');
                }
            });
        },
        alertPleaseMakePaymentForExam(router) {
            this.$swal({
                title: this.$PPlusEngine.getDictionary(this.$route.params.lang, 
                    'โปรดทำการชำระเงินสำหรับทำการสอบใหม่', 
                    'Please make payment for taking the exam again'),
                text: this.$PPlusEngine.getDictionary(this.$route.params.lang, 
                    'เนื่องด้วยนโยบายการสอบซ่อมของทางเรา ท่านได้ใช้โควต้าในการสอบซ่อมครบตามกำหนดแล้ว ดังนั้นท่านต้องทำการชำระเงินสำหรับเข้าสอบอีกครั้ง', 
                    'Due to our exam policy, you have reached the quota for your re-exam already. So, you are required to make another payment for re-exam again.'),
                type: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#cc4a4e',
                cancelButtonColor: '#ccc',
                confirmButtonText: this.$PPlusEngine.getDictionary(this.$route.params.lang, 
                    'ไปหน้าจ่ายเงิน', 
                    'Go to Payment')
            }).then((result) => {
                if (result.value) {
                    router.push('/' + this.$route.params.lang +'/payment');
                }
            });
        },
        alertPleaseWaitForPaymentConfirm() {
            this.$swal({
                title: this.$PPlusEngine.getDictionary(this.$route.params.lang, 
                    'รอยืนยันการชำระเงิน', 
                    'Wait for Confirm Payment'),
                text: this.$PPlusEngine.getDictionary(this.$route.params.lang, 
                    'ระบบอยู่ระหว่างยืนยันการชำระเงินของท่าน โปรดรอสักครู่', 
                    'Your account is in progress of reviewing the payment information'),
                type: 'warning'
            });
        },
        alertSystemError() {
            this.$swal({
                title: this.$PPlusEngine.getDictionary(this.$route.params.lang, 
                    'เกิดปัญหาระบบขัดข้อง', 
                    'System Error'),
                text: this.$PPlusEngine.getDictionary(this.$route.params.lang, 
                    'พบข้อผิดพลาดในเซิฟเวอร์หรือเครือข่าย โปรดลองอีกครั้ง', 
                    'Sorry, there is something wrong the system or network. Please try again'),
                type: 'error'
            });
        }
    }
}